import { Box, Grid } from "@mui/material";

import TreeMapChart from "./TreeMapChart";
import TreeMapMobileChart from "./TreeMapMobileChart";
import ModalTrigger from "../Common/ModalTrigger";

const BabyFood = (props) => {
  return (
    <Grid
      flexWrap="nowrap"
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
      alignItems="center"
    >
      <Grid item xs p={3} order={{ xs: 2, sm: 2, md: 1 }}>
        <Box sx={{ display: { xs: "none", sm: "block", md: "block" } }}>
          <TreeMapChart title="Number of samples per food products for infants and young children" />
        </Box>
        <Box
          sx={{
            display: { xs: "block", sm: "none", md: "none" },
            maxWidth: { xs: "300px" },
          }}
        >
          <TreeMapMobileChart title="Number of samples per food products for infants and young children" />
        </Box>
      </Grid>
      <Grid
        item
        xs
        className="eight-two"
        order={{ xs: 1, sm: 1, md: 2 }}
        sx={{ maxWidth: { md: "450px !important" } }}
      >
        <Box
          sx={{
            paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
            paddingRight: { xs: "24px", sm: "45x", md: "24px" },
            paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
            textAlign: { xs: "left", sm: "center", md: "left" },
          }}
        >
          <h3>Food for infants and young children samples</h3>
          <p className="paragraph">
            Reporting countries analysed 1,504 samples of different foods for infants and young children.
          </p>
          <p className="paragraph">
            Of the total number of baby food samples analysed, 477 samples were labelled as organic, and 440 samples were reported under the EU MACP.
          </p>
        </Box>
      </Grid>
    </Grid>
  );
};

export default BabyFood;
